import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=3fa79b3e"
import script from "../../services/school/school-list.js?vue&type=script&lang=js&external"
export * from "../../services/school/school-list.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports